import { Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

// `children` renders after the message, inside the same red line - for the cases where the error
// can point somewhere actionable (a conflicting record, a settings page) rather than only describe
// itself.
const ErrorMessage = ({ message, style = {}, className = '', children }) => {
  // `children` counts as something to render: an error that carries only a link would otherwise
  // leave the admin with a flagged field and no explanation of it. Callers that pass no children
  // are unaffected - a bare message-less call still renders nothing.
  if (!message && !children) {
    return null;
  }

  const renderMessageWithLineBreaks = (text) => {
    return text.split('\n').map((line, index, array) => (
      <span key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <Text c="red" className={className} style={style}>
      <IconAlertTriangle size={16} style={{ verticalAlign: 'middle', marginRight: 4 }} />
      {message && renderMessageWithLineBreaks(message)}
      {children}
    </Text>
  );
};

export default ErrorMessage;
